<nav class="app-frms-navbar navbar navbar-expand-lg  fixed-top" [attr.data-background-color]="backGroundColor">
    <nav-icon-toggle-1 [type]="'arrow-left'" [closed]="false" (toggled)="toggleSidebar($event)">
    </nav-icon-toggle-1>
    <div class="logo-wrapper">
        <div class="logo-img">
            <img src="/config/brand/{{logopath}}.png" />
        </div>
        <div class="logo-text-wrapper">
            <div class="logo-text">{{user?.company?.name}}</div>
            <div class="logo-version">v{{version}}</div>
        </div>
    </div>
    <div class="container-fluid">
        <div class="collapse navbar-collapse justify-content-end" id="navigation">
            <ul class="navbar-nav navbar-toolbox">
                <li class="nav-item dropdown" dropdown placement="bottom right">
                    <a class="nav-link" role="button" (click)="shownotiifications()">
                        <i class="fa fa-bell"><span *ngIf="notificationsCount>0"
                                class="badge badge-info badgeonicon">{{notificationsCount}}</span></i>
                    </a>
                </li>
                <!--                 <li class="nav-item dropdown" dropdown placement="bottom right">

                    <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                        dropdownToggle (click)="false">
                        <i class="fa fa-bell"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
                        <app-fr-uploadbar (showUploadViewEvent)="showUploadViewEventHandler($event)"></app-fr-uploadbar>
                    </div>
                </li> -->
                <!--                 <li class="nav-item dropdown" dropdown placement="bottom right">
                    <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                        dropdownToggle (click)="false">
                        <i class="fa fa-cog"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
                        <a class="dropdown-item" (click)="cleanCache()"><i class="fas fa-minus-circle"></i> Clean cache</a>
                    </div>
                </li> -->
                <li class="nav-item dropdown" dropdown placement="bottom right">
                    <a class="nav-link" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false"
                        dropdownToggle (click)="false">
                        <i class="fa fa-user"></i>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
                        <!-- <div class="dropdown-header"><strong>{{userfullname}}</strong></div> -->
                        <div class="user-profile">
                            <img src="./assets/img/avatars/user.jpg" class="user-profile-image mx-auto d-block"
                                alt="User image" title="Profile" aria-hidden="true">
                            <div class="gb_cb">
                                <div class="userfullname">{{userfullname}}</div>
                                <div class="email">{{user.username}}</div>
                            </div>
                        </div>
                        <!--                         <a class="dropdown-item"><i class="fa fa-tasks"></i> Tasks<span
                                class="badge badge-danger">42</span></a>
                        <div class="dropdown-header"><strong>Settings</strong></div>
                        <a class="dropdown-item"><i class="fa fa-wrench"></i> Settings</a>
                        <div class="divider"></div> -->

                        <a class="dropdown-item" (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
                        <div class="divider"></div>
                        <div class="dropdown-header"><i class="fas fa-cog mr-1"></i> <strong>Settings</strong></div>
                        <div class="p-3">
                            <h6><i class="fas fa-palette"></i> Theme colors</h6>
                            <a class="switch-trigger active-color" href="javascript:void(0)">
                                <div class="ml-auto mr-auto">
                                    <button type="button" class="btn btn-light btn-sm" (click)="changeUIColor('light')">Light Style</button>
                                    <button type="button" class="btn btn-dark  btn-sm"  (click)="changeUIColor('darkblue')">Dark Style</button>
                                </div>
                                <div class="clearfix"></div>
                                <div class="ripple-container"></div>

                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

    </div>
</nav>

<frms-fsidebar [(visible)]="notificationsDisplay" position="right" styleClass="sidebar-notifications p-sidebar-md"
    baseZIndex="28">
    <div class="notification-div">
        <h3>Notifications</h3>
    </div>

    <ng-container *ngIf="uploadQueueItemsCount()>0">
        <div class="notification-item">
            <div class="notification-header"><i class="fas fa-list"></i> <strong> Loading files to server</strong></div>
            <div class="notification-subitem">
                <a class="dropdown-item" (click)="showUploadViewEventHandler()" matTooltip="Click to view queue"> <span
                        class="badge badge-info mr-1">{{uploadQueueItemsCount()}}</span> Files in queue</a>
            </div>
        </div>
    </ng-container>
    <frms-notificationview></frms-notificationview>
    <!--     <div class="notification-item" *ngFor="let item of notifications">
        <div class="" [innerHtml]="item.messagestr"></div>
        
    </div> -->
</frms-fsidebar>

<!-- <nav class="navbar navbar-transparent navbar-absolute">
    <div class="container-fluid">
        <div class="navbar-header">
            <button mat-raised-button type="button" class="navbar-toggle" data-toggle="collapse" (click)="sidebarToggle()">
                <span class="sr-only">Toggle navigation</span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" >{{getTitle()}}</a>
        </div>
        <div class="collapse navbar-collapse">
            <ul class="nav navbar-nav navbar-right">
                <li>
                    <a href="#pablo" class="dropdown-toggle" data-toggle="dropdown">
                        <i class="material-icons">dashboard</i>
                        <p class="hidden-lg hidden-md">Dashboard</p>
                    </a>
                </li>
                <li class="dropdown">
                    <a  class="dropdown-toggle" data-toggle="dropdown">
                        <i class="material-icons">notifications</i>
                        <span class="notification">5</span>
                        <p class="hidden-lg hidden-md">Notifications</p>
                    </a>
                    <ul class="dropdown-menu">
                        <li><a >Mike John responded to your email</a></li>
                        <li><a >You have 5 new tasks</a></li>
                        <li><a >You're now friend with Andrew</a></li>
                        <li><a >Another Notification</a></li>
                        <li><a >Another One</a></li>
                    </ul>
                </li>
                <li>
                    <a href="#pablo" class="dropdown-toggle" data-toggle="dropdown">
                       <i class="material-icons">person</i>
                       <p class="hidden-lg hidden-md">Profile</p>
                    </a>
                </li>
            </ul>

            <form class="navbar-form navbar-right" role="search">
                <div class="form-group form-black is-empty">
                    <input type="text" class="form-control form-control-sm" placeholder="Search">
                    <span class="material-input"></span>
                </div>
                <button mat-raised-button type="submit" class="btn btn-white btn-round btn-just-icon">
                    <i class="material-icons">search</i><div class="ripple-container"></div>
                </button>
            </form>
        </div>
    </div>
</nav>  -->

<!-- <nav class="navbar navbar-expand-sm navbar-light navbar-section-header justify-content-between section-header nav-2rows">
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <div class="ml-auto d-flex justify-content-end">
        <ul class="nav navbar-nav ml-auto">
          <li class="nav-item d-md-down-none">
            <a class="nav-link" ><i class="icon-bell"></i><span class="badge badge-pill badge-danger">5</span></a>
          </li>
          <li class="nav-item dropdown" dropdown placement="bottom right">
            <a class="nav-link" data-toggle="dropdown"  role="button" aria-haspopup="true" aria-expanded="false"
              dropdownToggle (click)="false">
              <i class="fa fa-user"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right" *dropdownMenu aria-labelledby="simple-dropdown">
              <div class="dropdown-header"><strong>Account</strong></div>
              <a class="dropdown-item" ><i class="fa fa-file"></i> Projects<span
                  class="badge badge-primary">42</span></a>
              <div class="dropdown-header"><strong>Settings</strong></div>
              <a class="dropdown-item" ><i class="fa fa-user"></i> Profile</a>
              <a class="dropdown-item" ><i class="fa fa-wrench"></i> Settings</a>
        
              <div class="divider"></div>
              <a class="dropdown-item"  (click)="logout()"><i class="fa fa-lock"></i> Logout</a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav> -->